import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import BoxNumber from '../../common/BoxNumber'

function RatingBoxes({ type, data, selectedDuration }) {
  const { t } = useTranslation()
  return (
    <div className={styles.boxes}>
      <BoxNumber
        highlight={data && data[selectedDuration]?.engagement_rate?.value}
        text={t('dashboard.digest.engagementRate')}
        variation={data && data[selectedDuration]?.engagement_rate_variation?.value}
        image='stars-eye'
        className={styles.box}
      />
      {type === 'workplace' && (
        <BoxNumber
          highlight={data && data[selectedDuration]?.Belong_to_a_group?.value}
          text={t('dashboard.digest.belongToAGroup')}
          variation={data && data[selectedDuration]?.Belong_to_a_group_variation?.value}
          image='stars-group'
          className={`${styles.box} ${styles.groupsBox}`}
        />
      )}
      {type === 'group' && (
        <BoxNumber
          highlight={data && data[selectedDuration]?.Mixr_participation?.value}
          text={t('dashboard.digest.participatedInMixr')}
          variation={data && data[selectedDuration]?.Mixr_participation_variation?.value}
          image='stars-calendar'
          className={styles.box}
        />
      )}

      {type === 'workplace' && (
        <BoxNumber
          highlight={data && data[selectedDuration]?.Participated_in_a_mixr?.value}
          text={t('dashboard.digest.participatedInMixr')}
          variation={data && data[selectedDuration]?.Participated_in_a_mixr_variation?.value}
          image='stars-calendar'
          className={styles.box}
        />
      )}
    </div>
  )
}

export default RatingBoxes
